import { forwardRef } from "react";

import { useParseTranslationString } from "@/hooks/useParseTranslationString";
import { fastButtonVariants } from "@fastFields/fastButton/variants";
import { Button } from "@molecules/button";

import type { IFastButtonProps } from "@fastFields/fastButton/types";

export const FastButton = forwardRef<HTMLButtonElement, IFastButtonProps>(
  ({ type, label: propsLabel, entityName, ...restButtonProps }, ref) => {
    const { parseTranslatableString } = useParseTranslationString([
      "action",
      "entity",
      "page",
    ] as const);

    const { label: variantsLabel, ...variantProps } =
      fastButtonVariants(entityName)[type];

    const label = propsLabel || variantsLabel;

    return (
      <Button
        label={parseTranslatableString(label)}
        {...variantProps}
        {...restButtonProps}
        ref={ref}
      />
    );
  },
);

FastButton.displayName = "FastButton";
